export function convertToBase(input, base) {
  if (typeof input !== "number" || typeof base !== "number") {
    throw new Error("Both input and base must be numbers");
  }
  if (base < 2 || base > 36) {
    throw new Error("Base must be between 2 and 36");
  }
  return input.toString(base);
}